import { render } from "./FcForm.vue?vue&type=template&id=83a7c768&scoped=true"
import script from "./FcForm.vue?vue&type=script&lang=js"
export * from "./FcForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a7c768"]])

export default __exports__